<a href="#MenuListDemo">
  <h3 id="menuListDemo">Menu List Demos:</h3>
</a>

<h4>Triple Dot Menu:</h4>
<bulb-menu-list-panel [menuItems]="menuItems"></bulb-menu-list-panel>
<br>

<h4>Triple Dot Menu with disabled option, and warning color:</h4>
<bulb-menu-list-panel [menuItems]="menuItemsDisabledOption"></bulb-menu-list-panel>

<h4>Triple Dot Menu with link:</h4>
<bulb-menu-list-panel [menuItems]="menuItemsLinkedOption"></bulb-menu-list-panel>

<h4>Triple Dot Menu with descriptions and custom footer:</h4>
<bulb-menu-list-panel [menuItems]="menuItemsDescription">
  <ng-template #footerTemplate>
    <p>
      {{ customFooterContent }}
    </p>
  </ng-template>
</bulb-menu-list-panel>

<h4>Triple Dot Menu with custom button template</h4>
<bulb-menu-list-panel [menuItems]="menuItemsDescription">
  <ng-template #buttonTemplate>
    <aero-button #toggleElRef>
      <i class="fa fa-plus-square" aria-hidden="true"></i>
    </aero-button>
  </ng-template>
</bulb-menu-list-panel>

<h4>Triple Dot Menu with toggle button</h4>
<bulb-menu-list-panel [menuItems]="menuItemsToggle"></bulb-menu-list-panel>

<p-toast key="menuListDemo"></p-toast>
